import React from 'react';
import { FormattedText } from 'core/i18n';
import OkModalOnboarding from 'components/commons/OkModalOnboarding/OkModalOnboarding';

const documentRetryThanksModal = ({ onClose, modalIsOpen }) => {
    const handleClose = () => {
        onClose('cerrar');
    };

    const handleOK = () => {
        onClose('entendido');
    };

    return (
        <OkModalOnboarding onClose={handleClose} modalIsOpen={modalIsOpen}>
            <div className="container" style={{ width: '100%' }}>
                <div className="row" style={{ textAlign: 'center', marginTop: 30, marginBottom: 20 }}>
                    <span className="icons icons--icon-document" style={{ transform: 'scale(1.5)' }} />
                </div>
                <div className="row">
                    <div className="col-md-12 center-icon">
                        <p className="font-heading3">
                            <FormattedText value="documentRetryThanks-title" />
                        </p>
                    </div>
                </div>
                <div className="row">
                    <p className="col-md-12 center-icon">
                        <FormattedText value="documentRetryThanks-text1" />
                    </p>
                </div>
                <hr style={{ margin: 0, padding: 0, marginBottom: 20 }} />
                <div className="row" style={{ textAlign: 'right' }}>
                    <button className="form__button form__button-secondary" onClick={handleOK}>
                        <FormattedText value="button-understood" />
                    </button>
                </div>
            </div>
        </OkModalOnboarding>
    );
};
export default documentRetryThanksModal;
